import { render, staticRenderFns } from "./SetLocalStorage.vue?vue&type=template&id=25dfd225"
import script from "./SetLocalStorage.vue?vue&type=script&lang=js"
export * from "./SetLocalStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports